// extracted by mini-css-extract-plugin
export default {"Highlights":"Highlights_Highlights__72p7s","heading":"Highlights_heading__QR-AU"};